export default __webpack_public_path__ + "static/media/dog-illustration.20ec70ce.svg";